import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormItem } from '../form/FormItem';
import { FormGroup } from '@angular/forms';
import { FieldTypes } from '../../FieldTypes';

@Component({
  selector: 'vias-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
  @Input() item: FormItem;
  @Input() form: FormGroup;
  @Output() onclick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  type: string = 'button';
  color: string = 'primary';
  constructor() { }
  ngOnInit(): void {
    if (this.item.type === FieldTypes.Submit) {
      this.type = 'submit';
    }
    if (this.item.color !== undefined) {
      this.color = this.item.color;
    }
  }
  onClick($event: MouseEvent): void {
    this.onclick.emit($event);
  }
}
